<template>
  <v-form>
    <v-container>
      <v-layout>
        <div class="decretosBoton">
          <v-menu bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small tile outline color="primary">
                <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
              </v-btn>
            </template>
            <v-card class="px-2 py-1">
              <v-card-text class="black--text body-2">
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>
                  <b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas"</b>...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."
                </span>
                <br />
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>Corresponde declarar los depósitos en entidades financieras (bancos, mutuales, financieras, fondos de inversión, etc.) que se encuentren en el país o en el extranjero y estén a nombre del declarante, es decir, de dos o más personas; en cuyo caso debe declarar la totalidad del saldo de cuenta.</span>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto='<b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas"</b>...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."'
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto="Corresponde declarar los depósitos en entidades financieras (bancos, mutuales, financieras, fondos de inversión, etc.) que se encuentren en el país o en el extranjero y estén a nombre del declarante, es decir, de dos o más personas; en cuyo caso debe declarar la totalidad del saldo de cuenta."
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn color="success" dark @click.stop="dialog = true">
          <v-icon>add</v-icon>&nbsp;Adicionar
        </v-btn>
      </v-layout>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-dialog v-model="dialog" scrollable :max-width="deleteMode?600:1200" persistent>
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title>
                <h4>Depósitos en Entidades Financieras</h4>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <div class="decretosBoton">
                    <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                        </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>
                            <b>Tipo de Adquisición:</b> Especificar si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar.
                            <br />
                            <b>Descripción:</b> Detallar el tipo de cuenta (corriente, de ahorro, depósito a plazo, u otro.), el nombre de la entidad financiera donde se encuentra el depósito.
                            <br />
                            <b>Ubicación:</b> Indicar el país, departamento y localidad de ubicación de la cuenta.
                            <br />
                            <b>Moneda:</b> El valor debe ser expresado en moneda nacional (Bs) sin decimales, a la fecha de la Declaración. Para convertir monedas extranjeras a moneda nacional aplicará el tipo de cambio vigente al momento de la Declaración, según Tabla de Cotizaciones publicada por el Banco Central de Bolivia.
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>
                  <v-flex xs12 md12 class="decretos">
                    <alert-extendible
                      v-show="!deleteMode"
                      texto="<b>Tipo de Adquisición:</b> Especificar si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar. 
                      <br>
                      <b>Descripción:</b> Detallar el tipo de cuenta (corriente, de ahorro, depósito a plazo, u otro.), el nombre de la entidad financiera donde se encuentra el depósito.
                      <br>
                      <b>Ubicación:</b> Indicar el país, departamento y localidad de ubicación de la cuenta.
                      <br>
                      <b>Moneda:</b> El valor debe ser expresado en moneda nacional (Bs) sin decimales, a la fecha de la Declaración. Para convertir monedas extranjeras a moneda nacional aplicará el tipo de cambio vigente al momento de la Declaración, según Tabla de Cotizaciones publicada por el Banco Central de Bolivia."
                    ></alert-extendible>
                  </v-flex>
                  <v-flex xs12>
                    <v-alert
                      :value="true"
                      type="warning"
                      v-show="deleteMode"
                      outline
                    >¿Está seguro de eliminar el depósito en entidadades financieras siguiente?</v-alert>
                  </v-flex>
                  <!--popup-->
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      :no-data-text="$t('comun.sin_datos')"
                      v-model="tipoAdquisicion"
                      :items="itemsTipoAdquisicion"
                      item-text="tipadq_descripcion"
                      item-value="tipadq_codigo"
                      label="Tipo de Adquisición*"
                      :rules="dRules"
                      required
                      :disabled="deleteMode"
                    ></v-select>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      v-model="numeroCuenta"
                      :rules="nroCuentaRules"
                      label="Número de Cuenta*"
                      counter
                      required
                      maxlength="20"
                      :disabled="deleteMode"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="descripcion"
                          :rules="textRules"
                          label="Descripción, Ubicación, País*"
                          required
                          v-on="on"
                          maxlength="150"
                          :disabled="deleteMode"
                        ></v-text-field>
                      </template>
                      <span>
                        Descripción: Detallar el tipo de cuenta (corriente, de ahorro, depósito a plazo, u otro.), el nombre de la entidad financiera donde se encuentra el depósito.
                        <br />Ubicación: Indicar el país, departamento y localidad de ubicación de la cuenta.
                      </span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-currency-field
                      v-model="saldoCuenta"
                      :rules="numbersRules"
                      label="Saldo de Cuenta en Bs.*"
                      required
                      v-bind="currency_config"
                      :disabled="deleteMode"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-currency-field
                      v-model="tasasIntereses"
                      :rules="numbersRules"
                      label="Intereses Ganados en Bs.*"
                      required
                      :disabled="deleteMode"
                      v-bind="currency_config"
                    ></v-currency-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-textarea
                          @change="observaciones = $util.sanitiza(observaciones)"
                          v-model="observaciones"
                          label="Observaciones"
                          maxlength="250"
                          :rules="$validate(['text_area'])"
                          :disabled="deleteMode"
                          counter
                          hint="Máximo 250 caracteres."
                          v-on="on"
                          persistent-hint
                          rows="1"
                          auto-grow
                        ></v-textarea>
                      </template>
                      <span>
                        Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos de los “Depósitos en Entidades Financieras”, en particular:
                        Aquello que implique incremento o decremento en el saldo.
                        Si la cuenta (común) declarada se encuentra únicamente a nombre del cónyuge o conviviente.
                        Si se trata de una cuenta mancomunada.
                      </span>
                    </v-tooltip>
                  </v-flex>
                  <!--popup-->
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class="plomo--text">Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="deleteMode === true" color="primary" :loading="loadingButton" @click="repetidosModal = false, guardar()">
                  <v-icon>delete</v-icon>&nbsp;Eliminar</v-btn>
                  <v-btn v-if="deleteMode === false" color="primary" :loading="loadingButton" @click="preVerificacion()">
                    <v-icon>save</v-icon>&nbsp;Guardar</v-btn>
                <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-alert
            class="tamanioBoton"
            v-show="!habilitarLista"
            :value="true"
            color="info"
            icon="info"
          >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
        <v-flex v-show="habilitarLista">
          <v-data-table
            :headers="headers"
            :items="datos"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props" class="justify-center layout px-0">
              <td>{{ props.item.nro }}</td>
              <td>
                <v-tooltip top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="editItem(props.item)" v-on="on">
                      <v-icon color="blue">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top color="red">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="deleteItem(props.item)" v-on="on">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.tipadq_descripcion }}</td>
              <td>{{ props.item.depban_numero_cuenta }}</td>
              <td>{{ formatPrice(props.item.depban_saldo_cuenta) }}</td>
              <td>{{ formatPrice(props.item.depban_interes_cuenta) }}</td>
              <td>{{ props.item.depban_descripcion }}</td>
              <td><text-extendible :texto='props.item.depban_observacion'></text-extendible></td>
            </template>
            <template
              v-slot:pageText="props"
            >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="repetidosModal" scrollable persistent max-width="350">
          <v-card>
            <v-card-title>
              <h4>
                <v-icon color="yellow">warning</v-icon>Advertencia
              </h4>
            </v-card-title>
            <v-card-text>Intenta agregar o actualizar información que se registró anteriormente, el registro o actualización es responsabilidad del declarante.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="tamanioBoton"
                color="primary"
                flat
                @click="repetidosModal = false, guardar()"
              ><v-icon>save</v-icon>&nbsp;Agregar de todos modos</v-btn>
              <v-btn
                class="tamanioBoton"
                color="error"
                flat
                @click="repetidosModal = false, cancel()"
              ><v-icon>cancel</v-icon>&nbsp;Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
import jsonQuery from 'json-query';
export default {
  mixins: [ Parametricas, validate ],
  created () {
    if (this.$storage.get('ex') === 1 && this.itemsTipoAdquisicion.length === 0) {
      this.obtenerTipoAdquisicionParametrica().then(respuesta => {
        this.itemsTipoAdquisicion = respuesta.datos;
      });
      this.obtenerBienes();
    }
  },
  data: () => ({
    loadingButton: false,
    codDeposito: 0,
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      {
        text: 'Tipo de Adquisición',
        sortable: false,
        value: 'tipoAdquisicion'
      },
      { text: 'Número de Cuenta', sortable: false, value: 'numeroCuenta' },
      { text: 'Saldo de Cuenta en Bs.', sortable: false, value: 'saldoCuenta' },
      {
        text: 'Intereses Ganados en Bs.',
        sortable: false,
        value: 'tasasIntereses'
      },
      { text: 'Descripción', sortable: false, value: 'descripcion' },
      { text: 'Observaciones', sortable: false, value: 'observaciones' }
    ],
    datos: [],
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    itemsTipoAdquisicion: [],
    numeroCuenta: null,
    tipoAdquisicion: null,
    descripcion: '',
    saldoCuenta: 0,
    tasasIntereses: 0,
    observaciones: '',
    nro: 1,
    dialog: false,
    editMode: false,
    deleteMode: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [v => !!v || 'Este campo es requerido', v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#°ºñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜ$% \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    nroCuentaRules: [
      v => !!v || 'Nro de cuenta es requerido',
      v => /^[0-9]+$/.test(v) || 'El número de cuenta no es válido'
    ],
    numbersRules: [v => !!v || 'Este campo es requerido y debe ser un monto en Bolivianos',
      v => v.length < 11 || 'El valor solo puede tener máximo 8 números'],
    currency_config: {
      thousands: '.',
      decimal: ',',
      prefix: 'Bs.',
      precision: 0,
      masked: false,
      allowBlank: true
    },
    valid: true,
    habilitarLista: false,
    repetidosModal: false
  }),
  methods: {
    save () {
      let params = {
        cod_tipo_adquisicion: this.tipoAdquisicion,
        nro_cuenta: this.numeroCuenta,
        ubicacion: this.descripcion,
        saldo: this.saldoCuenta,
        tasa_interes: this.tasasIntereses,
        observacion: this.observaciones
      };
      this.$service
        .post(`djbr_registro/depositos_bancarios`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenerBienes();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    update () {
      let params = {
        cod_deposito: this.codDeposito,
        cod_tipo_adquisicion: this.tipoAdquisicion,
        nro_cuenta: this.numeroCuenta,
        ubicacion: this.descripcion,
        saldo: this.saldoCuenta,
        tasa_interes: this.tasasIntereses,
        observacion: this.observaciones
      };
      this.$service
        .put(`djbr_registro/depositos_bancarios`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.editMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    delete () {
      this.$service
        .delete(`djbr_registro/depositos_bancarios/${this.codDeposito}`)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    obtenerBienes () {
      this.$service
        .get(`djbr_registro/depositos_bancarios`, {})
        .then(response => {
          if (response.length >= 1 && response[0].depban_codigo !== -1) {
            this.datos = response;
            this.nro = 0;
            for (let i = 0; i < this.datos.length; i++) {
              this.datos[i].nro = ++this.nro;
              this.habilitarLista = true;
            }
          } else {
            this.datos = [];
            this.habilitarLista = false;
          }
        });
    },
    editItem (item) {
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.reinicializa();
      this.$refs.form.resetValidation();
      this.loadingButton = false;
    },
    preVerificacion () {
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        if (this.verificarRepetidos()) {
          this.repetidosModal = true;
        } else {
          this.guardar();
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    guardar () {
      if (this.editMode) {
        this.update();
      } else {
        if (this.deleteMode) {
          this.delete();
        } else {
          this.save();
        }
      }
    },
    reinicializa () {
      this.codDeposito = 0; // id
      this.tipoAdquisicion = null;
      this.numeroCuenta = null;
      this.descripcion = null;
      this.saldoCuenta = 0;
      this.tasasIntereses = 0;
      this.observaciones = '';
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.codDeposito = item.depban_codigo; // id
      this.tipoAdquisicion = item.tipadq_codigo;
      this.numeroCuenta = item.depban_numero_cuenta;
      this.descripcion = item.depban_descripcion;
      this.saldoCuenta = item.depban_saldo_cuenta.replace('.00', '');
      this.tasasIntereses = item.depban_interes_cuenta.replace('.00', '');
      this.observaciones = item.depban_observacion;
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace(',', '.').replace('.00', '');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    verificarRepetidos () {
      let data = { lista: this.datos };
      let comparing = {
        cod_tipo_adquisicion: this.tipoAdquisicion,
        nro_cuenta: this.numeroCuenta,
        ubicacion: this.descripcion.toUpperCase().trim(),
        saldo: typeof (this.saldoCuenta) === 'number' ? `${this.saldoCuenta}.00` : `${this.saldoCuenta}.00`,
        tasa_interes: typeof (this.tasasIntereses) === 'number' ? `${this.tasasIntereses}.00` : `${this.tasasIntereses}.00`,
        observacion: this.observaciones.toUpperCase().trim()
      };
      let resultQuery = jsonQuery(`lista[*tipadq_codigo=${comparing.cod_tipo_adquisicion} & 
                                   depban_saldo_cuenta=${comparing.saldo} &
                                   depban_interes_cuenta=${comparing.tasa_interes} &
                                   depban_numero_cuenta=${comparing.nro_cuenta} &
                                   depban_observacion=${comparing.observacion} &
                                   depban_descripcion=${comparing.ubicacion}]`, { data });
      if (this.editMode) {
        return resultQuery.value.length > 1;
      } else {
        return resultQuery.value.length > 0;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bienes/bienesDepositos.vue